import { Constants, InventoryItemUnderHood } from '@absg/nim-client-shared';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { PaginationControlsComponent } from 'shared.components/pagination-controls/pagination-controls.component';
import { StationListTypes } from 'shared.root/enums/stationlist-type.enum';

@Component({
  selector: '[nc-station-list-underhood]',
  templateUrl: './station-list-underhood.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StationListUnderhoodComponent implements OnInit {
  @Input() isUnderHoodModalOpen: boolean;
  @Input() set type(value: number) {
    this.setDynamicTextBasedOnType(value);
  }
  @Input() selectedItems: InventoryItemUnderHood[];

  pagingConfig: PaginationInstance = PaginationControlsComponent.getDefaultConfig();
  showQOHDiv = true;
  primaryHeader: string;
  subHeader: string;
  column1Text: string;
  column2Text: string;

  ngOnInit(): void {
    this.pagingConfig.itemsPerPage = 3;
    this.pagingConfig.currentPage = 1;
    this.pagingConfig.id = 'underhoodListPaging';
  }

  closeUnderHoodModal(): void {
    this.isUnderHoodModalOpen = false;
    this.pagingConfig.currentPage = 1;
  }

  trackItem(__: number, item: InventoryItemUnderHood): number {
    if (!item) { return undefined; }

    return item.stationContainerId;
  }

  private setDynamicTextBasedOnType(type: number): void {
    switch (type) {
      case StationListTypes.DispenseType:
        this.primaryHeader = Constants.dispenseTypeHeader;
        this.subHeader = Constants.dispenseTypeSecondaryHeader;
        this.column1Text = Constants.dispenseTypeColumn1;
        this.column2Text = Constants.dispenseTypeColumn2;
        this.showQOHDiv = false;
        break;
      default:
        this.primaryHeader = Constants.settingTypeHeader;
        this.subHeader = Constants.settingTypeSecondaryHeader;
        this.column1Text = Constants.settingTypeColumn1;
        this.column2Text = Constants.settingTypeColumn2;
        this.showQOHDiv = true;
        break;
    }
  }

}
